import Cookies from 'js-cookie';
import { getReceiverConfigurationUrl } from 'App/Settings/Workspace/Advanced/receiverConfigurationUrl';
import { parseReceiverConfiguration } from 'Components/parseXML';
import { CSRF_TOKEN } from 'javascript/interceptors/Headers';
import { ReceiverConfiguration } from 'Workspace/SchemeCallHandler/ReceiverConfigurationType';

export type NetworkFetchFunction = (url: string) => Promise<string>;

class ReceiverConfigurationReader {
	private static instance: ReceiverConfigurationReader;
	private configurationMap: Map<string, ReceiverConfiguration> = new Map();

	public constructor() {}

	public static getInstance(): ReceiverConfigurationReader {
		if (!ReceiverConfigurationReader.instance) {
			ReceiverConfigurationReader.instance = new ReceiverConfigurationReader();
		}
		return ReceiverConfigurationReader.instance;
	}

	private inBuiltBrowserFetch: NetworkFetchFunction = async (
		url: string
	): Promise<string> => {
		const receiverConfigurationUrl = getReceiverConfigurationUrl(url);
		// Why we have not use http.get() here?
		// This component would be needed in the case of purple UI plugin flow where we do not initiate http as it is unnecessary and it add up to the bundle size.
		const fetchRequest = await fetch(receiverConfigurationUrl, {
			headers: {
				[CSRF_TOKEN]: Cookies.get('CsrfToken') ?? '',
			},
		});
		const receiverConfigurationString = fetchRequest.ok && (await fetchRequest.text());
		return receiverConfigurationString;
	};

	private async fetchReceiverConfiguration(
		url: string,
		fetchFunction: NetworkFetchFunction = this.inBuiltBrowserFetch
	): Promise<ReceiverConfiguration> {
		try {
			const receiverConfigurationString = await fetchFunction(url);
			const receiverConfiguration =
				receiverConfigurationString &&
				parseReceiverConfiguration(receiverConfigurationString);
			receiverConfiguration && this.configurationMap.set(url, receiverConfiguration);
			return receiverConfiguration;
		} catch (error) {
			return null;
		}
	}

	public async read(
		url: string,
		fetchFunction: NetworkFetchFunction = this.inBuiltBrowserFetch
	): Promise<ReceiverConfiguration> {
		if (!this.configurationMap.has(url)) {
			await this.fetchReceiverConfiguration(url, fetchFunction);
		}
		return this.configurationMap.get(url);
	}
}

export const receiverConfigurationReader = ReceiverConfigurationReader.getInstance();
